import CButton from "@app/components/Common/CButton";
import { COLORS } from "@app/constants/STYLES";
import React, { useContext } from 'react';

import { useMitOrder } from '@app/hooks/trade/mitorder.tsx';
import { useTradeModalStore } from "@app/hooks/trade/modalStore";
import { useTradePosition } from "@app/hooks/trade/tradePosition";
import useWindowDimensions from "@app/hooks/useWindowDimensions";
import { Button, Space, Switch, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { View } from "../../../../../styles/reactnative";
import { ThemeContext } from "../../../../../theme/ThemeProvider";
import useCloseAllStore from "../closeAllStore";
import { TradeDetailHeaderSection } from "../styles";
import TradeShare from "./TradeShare";

const TradeDetailHeader = React.forwardRef<HTMLDivElement, { tabs: string; setTabs: (tab: string) => void; activedataLength?: any }>(
	({ tabs, setTabs, activedataLength }, ref) => {
		const { width } = useWindowDimensions();
		const { t } = useTranslation();
		const { textw } = useContext(ThemeContext).theme.COLORS;

		const { data: pos_list, orderlist: activeOrder, tpslList, mitLengtht } = useTradePosition();
		const { mitDataLength } = useMitOrder();
		const openpositioncount = " (" + (pos_list?.length || 0) + ")";
		const activecount = " (" + (activeOrder?.length + mitDataLength || 0) + ")";



		const data = [
			"positions",
			"openOrders",
			"positionHistory",
			"TradeHistory",
			// "cancel",
			"orderhistory",
			"transactionHistory",
		];
		const { data: tradeModalStore, mutate: muateTradeModalStore } =
			useTradeModalStore();

		// const closed = useCloseAllStore((state) => state.closed);
		const toggleClosed = useCloseAllStore((state) => state.toggleClosed);

		return (
			<TradeDetailHeaderSection ref={ref} className="drag-handle-positions">
			{/*<FloatBtnSection3 style={{ marginRight: 20 }} className={"drag-handle"}>*/}
			{/*	<IconArrowsMove />*/}
			{/*</FloatBtnSection3>*/}
			{/*<FloatBtnSection3*/}
			{/*	className="widgetClose"*/}
			{/*	onClick={() => {*/}
			{/*		muateTradeModalStore({*/}
			{/*			...tradeModalStore,*/}
			{/*			detailshow: tradeModalStore?.detailshow ? false : true,*/}
			{/*		});*/}
			{/*	}}*/}
			{/*>*/}
			{/*	X*/}
			{/*</FloatBtnSection3>*/}
			<View style={{ flexDirection: "row" }}>
				{data.map((item, index) => (
					<CButton
						key={index.toString()}
						title={
							t(item) +
							(item === "openOrders"
								? activecount
								: item === "positions"
									? openpositioncount
									: "")
						}
						onClick={() => {
							setTabs(item);
						}}
						textHover={COLORS.primary}
						style={{
							padding: 7,
							paddingBottom: 10,
							marginRight: 10,
							color: tabs === item ? COLORS.primary : COLORS.lightGray,
							borderBottomWidth: 1,
							borderBottomColor: tabs === item ? COLORS.primary : "transparent",
							borderRadius: 0,
							fontSize: width > 900 ? 14 : width > 600 ? 10 : 8,
							cursor:'pointer'
						}}
					/>
				))}
			</View>

			{tabs === "positions" && <Space style={{ marginRight: 40, color: textw }}>
				{t("current")}
				<Tooltip title={t("currentTooltip")}>
					<Switch
						checked={tradeModalStore?.iscurrent ? true : false}
						onChange={(value) => {
							muateTradeModalStore({
								...tradeModalStore,
								iscurrent: value,
							});
						}}
					/>
				</Tooltip>
				<Button
					type="primary"
					size="small"
					danger={true}
					onClick={() => {
						muateTradeModalStore({
							...tradeModalStore,
							iscurrent: false,
						});

						setTimeout(() => { toggleClosed() }, 1000)

					}}
				>
					{t("closeAll")}
				</Button>
			</Space>}

			{/* {tabs === "TradeHistory" && <TradeShare/>} */}
		</TradeDetailHeaderSection>
		);
	}
);

TradeDetailHeader.displayName = 'TradeDetailHeader';

export default React.memo(TradeDetailHeader);
